import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  overflow: hidden;
`;

interface GradientOverlayProps {
  $show: boolean;
}

export const GradientOverlay = styled.div<GradientOverlayProps>`
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 50px;
  pointer-events: none;
  opacity: ${({ $show }) => ($show ? 1 : 0)};
  transition: opacity 0.2s;
  background: ${({ theme }) => `linear-gradient(
    90deg, 
    ${theme.colorBgContainer}00 0%, 
    ${theme.colorBgContainer}A6 25%, 
    ${theme.colorBgContainer} 50%
  )`};
`;
